import { Status } from 'state/interfaces'

export interface ITask {
  id: number
  start: string
  end: string
  postLifetime: number
  duration: number
  multiplier: number
  status: Status
  title: string
  description: string
  docLink: string
}

export enum TaskStatus {
  INITIAL, // ничего не делали
  PENDING, // отправил запрос на бэк, что задача выполнена (мог и не выполнять)
  CONFIRMED, // бэк подтвердил, что задача выполнена
  ACTIVE, // задача сейчас активна. это с сабграфа берем. уже есть эта логика
  USED, // задача была выполнена и использована
}

// export interface ITaskOld {
//   id: number
//   start: string
//   end: string
//   postLifetime: number
//   duration: number
//   multiplier: number

//   title: string
//   description: string
//   docLink: string
// }
